const indicar_ensino_fase_de_destino = [
  {
    path: "/indicar-ensino-fase-de-destino",
    name: "indicar_ensino_fase_de_destino",
    meta: {
      requireAuth: false,
      breadCrumb: "Processo de Resultado Final - Educação Especial",
    },
    component: () =>
      import(
        "@/views/IndicarEnsinoFaseDeDestino/IndicarEnsinoFaseDeDestino.vue"
      ),
  },
];

export { indicar_ensino_fase_de_destino };
